module.exports = __webpack_public_path__ + "static/media/location-marker.f01e4357.svg";